import React, { Component } from 'react';
import 'scss/pages.scss';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Base from 'components/base/secure/base';
import BudgetPage from 'modules/budget/pages/budget';
import Error404 from 'components/base/errors/error-404';
import Login from 'components/base/public/login/login';
import Register from 'components/base/public/register/register';
import CategoryPage from 'modules/budget/pages/category-page';
import FamilyModule from 'modules/family/family-module';

@inject('store')
@withRouter
@observer
class App extends Component {
    componentDidMount() {
        // Check whether this is mobile
        if(document.body.clientWidth < 991) {
            this.props.store.app.setMobile(true);
        } else {
            this.props.store.app.setMobile(false);
        }
    }

    render() {
        const { token } = this.props.store.auth;

        return (token
            ? (
                <Base>
                    <Switch>
                        <Route exact path="/" component={BudgetPage} />
                        <Route path="/categories" component={CategoryPage} />
                        <Route path="/family" component={FamilyModule} />
                        <Redirect from="/login" to="/" />
                        <Redirect from="/register" to="/" />
                        <Route component={Error404} />
                    </Switch>
                </Base>
            ) : (
                <Switch>
                    <Route path="/login" component={Login} />
                    <Route path="/register" component={Register} />
                    <Redirect from="/" to="/login" />
                    <Route path="*" component={Error404} />
                </Switch>
            )
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js